export default "__VITE_PUBLIC_ASSET__70053718__"